import React, { useState } from "react";
import { Form } from "react-bootstrap";
import {
  MdVisibility,
  MdModeEditOutline,
  MdDelete,
  MdContentCopy,
} from "react-icons/md";
import { FaSearch } from "react-icons/fa";
import Pagination from "../../../helper/Pagination";
import { LiaCheckDoubleSolid } from "react-icons/lia";
import { useNavigate } from "react-router-dom";
const OEMPartnerTable = ({
  partners,
  loading,
  statusFilter,
  setStatusFilter,
  searchTerm,
  handleSearchChange,
  copiedId,
  setCopiedId,
  handleViewDetails,
  handleEditClick,
  removePartner,
  handleStatusChange,
  currentPage,
  pagination,
  setCurrentPage,
}) => {
  const navigate = useNavigate();
  const handleRowClick = (partner) => {
    // setSelectedOemId(partner._id);
    // setShowUserList(true);
    navigate("/oem-user-details", { state: { partner } });
  };
  return (
    <div className="table-section">
      <div className="d-flex justify-content-between gap-4 align-items-center mb-2">
        <div className="">
          <button
            className={`me-2 add-btn ${
              statusFilter === "active" ? "active" : ""
            }`}
            onClick={() =>
              setStatusFilter(statusFilter === "active" ? "" : "active")
            }
            style={{
              background:
                statusFilter === "active"
                  ? "linear-gradient(135deg, #1e40af, #3b82f6)"
                  : statusFilter === "inactive"
                    ? "#f8f9fa"
                    : "",
              color:
                statusFilter === "active"
                  ? "white"
                  : statusFilter === "inactive"
                    ? "#666"
                    : "",
            }}
          >
            Active
          </button>
          <button
            className={`add-btn ${statusFilter === "inactive" ? "active" : ""}`}
            onClick={() =>
              setStatusFilter(statusFilter === "inactive" ? "" : "inactive")
            }
            style={{
              background:
                statusFilter === "inactive"
                  ? "linear-gradient(135deg, #1e40af, #3b82f6)"
                  : statusFilter === "active"
                    ? "#f8f9fa"
                    : "",
              color:
                statusFilter === "inactive"
                  ? "white"
                  : statusFilter === "active"
                    ? "#666"
                    : "",
            }}
          >
            Inactive
          </button>
        </div>

        <div className="d-flex gap-3">
          <div className="position-relative">
            <input
              type="search"
              placeholder="Search OEM..."
              className="form-input"
              value={searchTerm}
              onChange={handleSearchChange}
              style={{ width: "220px" }}
            />
            {searchTerm === "" && (
              <div
                className="position-absolute"
                style={{
                  top: "50%",
                  right: "13px",
                  color: "#666",
                  transform: "translateY(-50%)",
                }}
              >
                <FaSearch />
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="table-scroll-wrapper">
        <table className="partners-table">
          <thead>
            <tr>
              <th>Sr No.</th>
              <th>Company Name</th>
              <th>Email</th>
              <th>Contact Number</th>
              <th>Country (Currency)</th>
              <th>Password</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td
                  colSpan="12"
                  style={{
                    textAlign: "center",
                    padding: "40px",
                    color: "#666",
                  }}
                >
                  <div className="loading-spinner">
                    {/* <div className="spinner"></div> */}
                    {/* <p>Loading...</p> */}
                  </div>
                </td>
              </tr>
            ) : partners.length === 0 ? (
              <tr>
                <td
                  colSpan="12"
                  style={{
                    textAlign: "center",
                    padding: "20px",
                    color: "#666",
                  }}
                >
                  No partners added yet
                </td>
              </tr>
            ) : (
              partners
                .filter((partner) => partner && partner.companyName)
                .map((partner, index) => (
                  <tr key={partner._id} style={{ cursor: "pointer" }}>
                    <td onClick={() => handleRowClick(partner)}>
                      {(currentPage - 1) * 10 + index + 1}
                    </td>

                    <td
                      onClick={() => handleRowClick(partner)}
                      title={
                        partner.companyName && partner.companyName.length > 20
                          ? partner.companyName
                          : ""
                      }
                      style={{
                        cursor:
                          partner.companyName && partner.companyName.length > 20
                            ? "pointer"
                            : "default",
                      }}
                    >
                      {partner.companyName
                        ? partner.companyName.length > 20
                          ? partner.companyName.charAt(0).toUpperCase() +
                            partner.companyName.substring(1, 20) +
                            "..."
                          : partner.companyName.charAt(0).toUpperCase() +
                            partner.companyName.slice(1)
                        : "N/A"}
                    </td>
                    <td onClick={() => handleRowClick(partner)}>
                      {partner.email || "N/A"}
                    </td>
                    <td onClick={() => handleRowClick(partner)}>
                      {partner.countryCode && partner.contactNumber
                        ? `(${partner.countryCode}) ${partner.contactNumber}`
                        : partner.contactNumber || "N/A"}
                    </td>
                    <td onClick={() => handleRowClick(partner)}>
                      {partner.country && partner.currency
                        ? `${partner.country} (${partner.currency})`
                        : partner.country || partner.currency || "N/A"}
                    </td>
                    <td>
                      <div className="password-cell">
                        <span>
                          {partner.plainPassword ? "************" : "N/A"}
                        </span>
                        {partner.plainPassword &&
                          partner.plainPassword !== "N/A" && (
                            <div
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "8px",
                                marginLeft: "8px",
                              }}
                            >
                              {copiedId === partner._id ? (
                                <LiaCheckDoubleSolid
                                  className="copy-icon"
                                  style={{
                                    color: "#28a745",
                                    fontSize: "12px",
                                  }}
                                  title="Copied!"
                                />
                              ) : (
                                <MdContentCopy
                                  className="copy-icon"
                                  style={{
                                    color: "#007bff",
                                    cursor: "pointer",
                                  }}
                                  onClick={(e) => {
                                    const text = partner.plainPassword;

                                    if (
                                      typeof navigator !== "undefined" &&
                                      navigator.clipboard &&
                                      window.isSecureContext
                                    ) {
                                      navigator.clipboard
                                        .writeText(text)
                                        .then(() => {
                                          setCopiedId(partner._id);
                                          setTimeout(
                                            () => setCopiedId(null),
                                            2000,
                                          );
                                        })
                                        .catch(() => {
                                          const textArea =
                                            document.createElement("textarea");
                                          textArea.value = text;
                                          textArea.style.position = "fixed";
                                          document.body.appendChild(textArea);
                                          textArea.focus();
                                          textArea.select();
                                          document.execCommand("copy");
                                          document.body.removeChild(textArea);

                                          setCopiedId(partner._id);
                                          setTimeout(
                                            () => setCopiedId(null),
                                            2000,
                                          );
                                        });
                                    } else {
                                      const textArea =
                                        document.createElement("textarea");
                                      textArea.value = text;
                                      textArea.style.position = "fixed";
                                      document.body.appendChild(textArea);
                                      textArea.focus();
                                      textArea.select();
                                      document.execCommand("copy");
                                      document.body.removeChild(textArea);

                                      setCopiedId(partner._id);
                                      setTimeout(() => setCopiedId(null), 2000);
                                    }
                                  }}
                                  title="Copy Password"
                                />
                              )}
                            </div>
                          )}
                        {/* {partner.plainPassword &&
                          partner.plainPassword !== "N/A" && (
                            <MdContentCopy
                              className="copy-icon"
                              style={{
                                color:
                                  copiedId === partner?._id
                                    ? "#28a745"
                                    : "#007bff",
                              }}
                              onClick={(e) => {
                                const text = partner.plainPassword;

                                // safe clipboard copy
                                if (
                                  typeof navigator !== "undefined" &&
                                  navigator.clipboard &&
                                  window.isSecureContext
                                ) {
                                  navigator.clipboard
                                    .writeText(text)
                                    .then(() => {
                                      setCopiedId(partner._id);
                                      setTimeout(() => setCopiedId(null), 2000);
                                    })
                                    .catch(() => {
                                      // fallback
                                      const textArea =
                                        document.createElement("textarea");
                                      textArea.value = text;
                                      textArea.style.position = "fixed";
                                      document.body.appendChild(textArea);
                                      textArea.focus();
                                      textArea.select();
                                      document.execCommand("copy");
                                      document.body.removeChild(textArea);

                                      setCopiedId(partner._id);
                                      setTimeout(() => setCopiedId(null), 2000);
                                    });
                                } else {
                                  // fallback always on http
                                  const textArea =
                                    document.createElement("textarea");
                                  textArea.value = text;
                                  textArea.style.position = "fixed";
                                  document.body.appendChild(textArea);
                                  textArea.focus();
                                  textArea.select();
                                  document.execCommand("copy");
                                  document.body.removeChild(textArea);

                                  setCopiedId(partner._id);
                                  setTimeout(() => setCopiedId(null), 2000);
                                }
                              }}
                              title={
                                copiedId === partner?._id
                                  ? "Copied!"
                                  : "Copy password"
                              }
                            />
                          )} */}
                      </div>
                    </td>
                    <td className="">
                      <Form.Switch
                        className={
                          partner?.status === "active"
                            ? "custom-active info_pointer"
                            : ""
                        }
                        checked={partner?.status === "active"}
                        onChange={(e) => {
                          handleStatusChange(partner);
                        }}
                      />
                    </td>
                    <td>
                      <div className="row-actions">
                        <div
                          onClick={(e) => {
                            handleViewDetails(partner);
                          }}
                          className="view-row-btn"
                          title="View Details"
                          style={{
                            color: "#666",
                            cursor: "pointer",
                            marginRight: "8px",
                          }}
                        >
                          <MdVisibility />
                        </div>
                        <div
                          onClick={(e) => {
                            handleEditClick(partner);
                          }}
                          className="edit-row-btn"
                          title="Edit"
                        >
                          <MdModeEditOutline />
                        </div>
                        <div
                          onClick={(e) => {
                            removePartner(partner);
                          }}
                          className="delete-row-btn"
                          title="Delete"
                        >
                          <MdDelete />
                        </div>
                      </div>
                    </td>
                  </tr>
                ))
            )}
          </tbody>
        </table>
      </div>

      <Pagination
        currentPage={currentPage}
        totalPages={pagination.totalPages}
        totalItems={pagination.totalItems}
        itemsPerPage={pagination.itemsPerPage}
        onPageChange={setCurrentPage}
      />
      {/* Copy Success Toast */}
      {copiedId && (
        <div
          style={{
            position: "fixed",
            // bottom: "30px",
            top: "20px",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "#28a745",
            color: "white",
            padding: "12px 20px",
            borderRadius: "8px",
            fontSize: "14px",
            fontWeight: "500",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            zIndex: 9999,
            boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
            animation: "slideUp 0.3s ease-out",
          }}
        >
          <LiaCheckDoubleSolid style={{ fontSize: "16px" }} />
          Copied
        </div>
      )}

      <style>
        {`
                @keyframes slideUp {
                  from {
                    opacity: 0;
                    transform: translateX(-50%) translateY(20px);
                  }
                  to {
                    opacity: 1;
                    transform: translateX(-50%) translateY(0);
                  }
                }
              `}
      </style>
    </div>
  );
};

export default OEMPartnerTable;
